import { Dropdown } from 'primereact/dropdown';
import React, { Component } from 'react';
import './CustomDropdown.less';

class CustomDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {}

  render() {
    const { props } = this;
    const { label, rounded, ...dropdownProps } = props;
    const containerClass = `custom-dropdown${rounded ? ' rounded' : ''}`;
    
    return (
      <div className={containerClass}>
        {label && <div className="title">{label}</div>}
        <Dropdown {...dropdownProps} />
      </div>
    );
  }
}

CustomDropdown.propTypes = {};

export default CustomDropdown;
